import { render, staticRenderFns } from "./Dowjones-Specialone.vue?vue&type=template&id=63985b87&"
import script from "./Dowjones-Specialone.vue?vue&type=script&lang=js&"
export * from "./Dowjones-Specialone.vue?vue&type=script&lang=js&"
import style0 from "./Dowjones-Specialone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports